const GraphQLMultiQuery = require('app/graphql/MultiQuery');
const GraphQLQuery = require('app/graphql/Query');

class TrameTab {
    defaultOptions() {
        return {
            '$container': $('<div/>'),
            'restaurant': {'id':null,'name':null},

        };
    }

    constructor(options) {
        this.settings = $.extend(this.defaultOptions(), options);

        this.$container = this.settings.$container;
        if(this.$container.length <= 0){
            window.notify("Can't find container view with selector " + this.settings.selector,'danger');
        }

        this.restaurant = this.settings.restaurant;

        this.initialize();
    }

    initialize() {
        var self = this;

        this.loadData();
    }

    loadData(){
        var self = this;

        this.$container
        .html('')
        .append(window.App.generateLoader())

        let queries = [
            this.buildRestaurantUsersQuery(),
        ];

        let query = new GraphQLMultiQuery({
            //parameters
            'queries': queries,

            //callbacks
            'before': function(){
            },
            'success': function(data){
                self.buildTab(data);
            },
            'error': function(message, data){
                console.error(message,data);
                window.notify(message,"danger");
            },
            'after': function(){
            }
        });

        query.execute();
    }

    buildRestaurantUsersQuery(){
        var self = this;

        let id = this.restaurant.id;
        let parameters = {
            'id': id,
        };

        let fields = [
            'userAssociations { type user { id } }'
        ];

        let query = new GraphQLQuery({
            //parameters
            'queryType': 'restaurant',
            'parameters': parameters,
            'fields': fields,
            'hasEdges': false,
            'addPageInfo': false,
            'addTotalCount': false,
        });

        return query;
    }


    buildTab(data){
        this.userAssociations = data.restaurant.userAssociations;

        this.firstUser = null;
        for(var i in this.userAssociations){
            let userAssociation = this.userAssociations[i];
            if(userAssociation.user){
                this.firstUser = userAssociation.user;
                break;
            }
        }

        if(!this.firstUser){
            this.$container
            .html('')
            .append(
                $('<div/>')
                .addClass('alert alert-danger')
                .append(window.translate('app.restaurant.show.tabs.trame.noUserAssociated'))
            )
        }

        this.$content = $('<div/>')
        .addClass('white-box row')
        .append(
            $('<div/>')
            .addClass('col-6 d-flex justify-content-center')
            .append(
                this.buildWithPriceLink()
            )
        )
        .append(
            $('<div/>')
            .addClass('col-6 d-flex justify-content-center')
            .append(
                this.buildWithoutPriceLink()
            )
        )

        this.$container
        .html('')
        .append(this.$content)
    }

    buildWithPriceLink(){
        let userId = '';
        if(this.firstUser){
            userId = this.firstUser.id;
        }
        let url = window.App.get('oldAdminBaseUrl')+'/commandes/admin-access/'+this.restaurant.id+'&v2=1&pa=2&u='+userId;

        return $("<a/>")
        .attr('href',url)
        .attr('target',"_blank")
        .addClass('btn btn-secondary')
        .append(
            $('<i/>')
            .addClass('fas fa-search ms-1')
        )
        .append(window.translate('app.restaurant.show.tabs.trame.withPrice.label'))
    }
    buildWithoutPriceLink(){
        let userId = '';
        if(this.firstUser){
            userId = this.firstUser.id;
        }
        let url = window.App.get('oldAdminBaseUrl')+'/commandes/admin-access/'+this.restaurant.id+'&v2=1&pa=1&u='+userId;

        return $("<a/>")
        .attr('href',url)
        .attr('target',"_blank")
        .addClass('btn btn-primary')
        .append(
            $('<i/>')
            .addClass('fas fa-search ms-1')
        )
        .append(window.translate('app.restaurant.show.tabs.trame.withoutPrice.label'))
    }

}

module.exports = TrameTab;

